import { render, staticRenderFns } from "./achievement.vue?vue&type=template&id=3b58efcc&scoped=true&"
import script from "./achievement.vue?vue&type=script&lang=js&"
export * from "./achievement.vue?vue&type=script&lang=js&"
import style0 from "./achievement.vue?vue&type=style&index=0&id=3b58efcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58efcc",
  null
  
)

export default component.exports